import { setPlayingUI } from '../ui/visualizer';

export type BeatLinePlaybackButtonState = 'play' | 'pause' | 'replay';

export function setPlaybackButtonState(
  button: Element | null | undefined,
  state: BeatLinePlaybackButtonState,
  icons: { play: string; pause: string; replay: string }
): void {
  if (!(button instanceof HTMLElement)) return;

  button.removeAttribute('data-status');

  if (state === 'pause') {
    button.innerHTML = icons.pause;
    button.dataset.ended = '0';
    return;
  }

  if (state === 'replay') {
    button.innerHTML = icons.replay;
    button.dataset.ended = '1';
    button.setAttribute('data-status', 'replay');
    return;
  }

  button.innerHTML = icons.play;
  button.dataset.ended = '0';
}

export function syncPlayingState(playing: boolean, state?: Record<string, unknown>): void {
  if (state) state.isPlaying = !!playing;
  setPlayingUI(!!playing);
}
